import axios from 'axios';
import router from '../router';
import loadingStore from '../loading';

// Relative URL so the dev-server proxy in vue.config.js forwards to the real API
// on whatever port this app is running.
const apiURL = '/backend/api';

const apiClient = axios.create({
  baseURL: apiURL, // Replace with your API base URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// Dev-only demo data (npm run serve:mock), see services/api.js.
if (process.env.NODE_ENV !== 'production' && process.env.VUE_APP_MOCK === '1') {
  apiClient.defaults.adapter = require('../mock/adapter').default;
}

// Request interceptor to add the API token and show loading spinner
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('api_token'); // Adjust as needed
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export async function fetchUserInfo() {
    try {
      const response = await apiClient.get('/user'); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return { success: false, message: "No response received", details: error.request };
      } else {
        // Something happened in setting up the request that triggered an Error
        return { success: false, message: "Request setup error", details: error.message };
      }
    }
  }

  export async function fetchDashboardItems() {
    try {
      const response = await apiClient.get('/dashboard-items'); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return { success: false, message: "No response received", details: error.request };
      } else {
        // Something happened in setting up the request that triggered an Error
        return { success: false, message: "Request setup error", details: error.message };
      }
    }
  }

  export async function save(itemIds) {
  try {
    const response = await apiClient.post('/save-dashboard-items', {
      itemIds // this sends { itemIds: [8, 9, 10, ...] }
    });
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return { success: false, message: "No response received", details: error.request };
    } else {
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}
